export default __webpack_public_path__ + "static/media/Growth Associate.50e9787e.png";